import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { AuthProvider } from './features/auth/shared/auth-provider';
import { SessionTimeoutDialogComponent } from './features/auth/shared/session-timeout/session-timeout-dialog.component';

@Component({
  imports: [RouterOutlet, ToastModule, ConfirmDialog, SessionTimeoutDialogComponent],
  selector: 'app-root',
  template: `
    <app-session-timeout-dialog></app-session-timeout-dialog>
    <p-toast></p-toast>
    <p-confirm-dialog></p-confirm-dialog>
    <router-outlet></router-outlet>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class App implements OnInit {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthProvider);

  ngOnInit(): void {
    // Handle internal login redirect from MiArbolink (?token=xxx&data=base64)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const dataBase64 = urlParams.get('data');

    if (token && dataBase64) {
      try {
        // Decode base64 user data (same format as external login response)
        const jsonStr = atob(dataBase64);
        const userData = JSON.parse(jsonStr);
        this.auth.initializeFromRedirect(userData, token);
      } catch (e) {
        console.error('Failed to decode user data from redirect', e);
        this.auth.initializeFromToken(token);
      }
      // Clean URL without triggering navigation
      window.history.replaceState({}, '', window.location.pathname);
      this.router.navigateByUrl('/');
    }
  }
}

